var render = function render(){var _vm=this,_c=_vm._self._c;return _c('account-background',{attrs:{"product-name":_vm.productName,"theme-colour":_vm.themeColour,"id":"login-background"}},[_c('login-box',{staticClass:"mb-5",attrs:{"product-name":_vm.productName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }